const DateDescIcon = () => (
    <svg className="text-white" width="24" height="24" viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"
              stroke="currentColor" strokeWidth="2" fill="none" />
        <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2" />
        <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" />
        <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" />
        <path d="M12 14V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M9 17L12 20L15 17" stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default DateDescIcon;